/** Nome do produto (antes Kompil). Troque aqui e em VITE_BRAND_NAME. */
export const BRAND_NAME = "Kompil";

/** Cabeçalho exigido em toda requisição de escrita da API (proteção CSRF complementar). */
export const CSRF_HEADER = "x-kompil-csrf";

/** Nome do cookie de sessão (HttpOnly). */
export const SESSION_COOKIE = "kompil_session";

/** Limites de proteção do serviço de sync (seção 4.6). */
export const SYNC_LIMITS = {
  maxDocumentBytes: 5 * 1024 * 1024,
  maxMessageBytes: 1024 * 1024,
  /** Pessoas (abas) no mesmo arquivo ao mesmo tempo; configurável no sync (SYNC_MAX_PER_DOCUMENT). */
  maxConnectionsPerDocument: 200,
  /**
   * Documentos aguardando autorização numa mesma conexão. O app abre cada arquivo do projeto como
   * um documento na mesma conexão: o padrão do Hocuspocus (100) derrubava projetos com mais de 100
   * arquivos em loop. Configurável no sync (SYNC_MAX_PENDING_DOCUMENTS).
   */
  maxPendingDocuments: 5_000,
  maxMessagesPerSecond: 100,
} as const;

/** Valores iniciais do sandbox (seção 5.2), para calibrar com dados reais. */
export const SANDBOX_DEFAULTS = {
  cpus: 0.5,
  memoryMb: 512,
  diskMb: 1024,
  pidsLimit: 128,
  idleAfterMinutes: 5,
  hibernateAfterMinutes: 15,
  /**
   * Disco da nuvem (dependências, builds) guardado depois de hibernar. O código feito no terminal
   * já volta para o projeto; isto só evita reinstalar tudo ao voltar depois de semanas.
   */
  destroyAfterHours: 30 * 24,
  maxSessionHours: 4,
} as const;

/**
 * Nome da pasta do projeto no ambiente na nuvem: os projetos ficam em `/workspace` (a pasta dos
 * projetos) e cada um na pasta com o nome dele (o nome curto do projeto, ex.: `/workspace/meu-site`).
 */
export function sandboxFolderName(slug: string | null | undefined): string {
  const clean = (slug ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9._-]+/g, "-")
    .replace(/^[-.]+|[-.]+$/g, "")
    .slice(0, 64);
  return clean || "projeto";
}

/**
 * Planos que incluem a nuvem (terminal e projeto rodando em contêiner próprio, com Node, Python,
 * Java, Go, Rust, PHP, Ruby…). O acesso é de cada pessoa: entrar num projeto ou grupo de alguém
 * que tem o plano não libera a nuvem.
 */
export const CLOUD_PLANS = ["business", "enterprise"] as const;
export const isCloudPlan = (plan: string | null | undefined) =>
  Boolean(plan && (CLOUD_PLANS as readonly string[]).includes(plan.trim().toLowerCase()));

/**
 * Arquivos binários e grandes do projeto: sobem em partes (cada parte cabe numa requisição e numa
 * linha do banco). Texto até `textMaxBytes` fica editável em tempo real; acima disso, vira arquivo.
 */
export const BLOB_LIMITS = {
  partBytes: 4 * 1024 * 1024,
  /** Um arquivo (logs, dumps, bancos): sem corte prático para projetos de código. */
  maxFileBytes: 2 * 1024 * 1024 * 1024,
  textMaxBytes: 4_000_000,
} as const;
